import React, { useState } from 'react';
import auth from '../AuthService';

export default function Setup2FA() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const secret = sessionStorage.getItem('twoSetupSecret') || '';
  const qrCode = sessionStorage.getItem('twoSetupQr') || '';
  const tempToken = auth.getTempToken();

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await auth.loginWith2FA(tempToken, code);
      if (res.token) {
        auth.clearTempToken();
        sessionStorage.removeItem('twoSetupSecret');
        sessionStorage.removeItem('twoSetupQr');
        auth.logout();
        window.location.replace('/');
      } else {
        setError('Invalid code. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="center">
      <div className="card">
        <h1>Setup Two-Factor Authentication</h1>
        <p>
          Open your authenticator app (Google Authenticator, FreeOTP, etc.)
          and scan the QR code below, or enter the secret manually.
        </p>
        {qrCode && <img src={qrCode} alt="2FA QR Code" style={{ maxWidth: '250px', margin: '10px 0' }} />}
        {secret && (
          <div style={{ margin: '10px 0', padding: '10px', background: '#f8f9fa', borderRadius: '4px', fontFamily: 'monospace', wordBreak: 'break-all' }}>
            <strong>Secret:</strong> {secret}
          </div>
        )}
        <form onSubmit={handleVerify}>
          <input
            className="form-item"
            placeholder="6-digit code..."
            type="text"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
          />
          {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
          <input className="form-submit" value={loading ? 'Verifying...' : 'Verify & Enable'} type="submit" disabled={loading || code.length !== 6} />
        </form>
      </div>
    </div>
  );
}
